module.exports = __webpack_public_path__ + "assets/img/4932-bz.svg";